/** O contrato de `/api/v1/frota-leve/anomalias` (03/11/2026), a Anomalia Frota desde
 *  04/11/2026, com o tipo de frota em `tipo`. */
import type { Categoria } from '../../../core/api/types'

/** A aba da Anomalia Frota, na ordem do Samuel: Frota Pesada, Frota Leve e Máquina. */
export type TipoDeFrota = 'pesada' | 'leve' | 'maquina'
export const TIPOS_DE_FROTA: readonly TipoDeFrota[] = ['pesada', 'leve', 'maquina']

/** De onde saiu o nome do motorista: o cartão do rastreador, a macro da TrucksControl,
 *  o conjunto do cavalo ou o operador da máquina no Maquinário. */
export type FonteDoMotorista = 'cartao' | 'macro' | 'conjunto' | 'operador'

export interface FrotaDaAnomalia {
  uuid: string
  placa: string | null
  rotulo: string | null
  modelo: string | null
  filial: string | null
  category: Categoria | null
  classificacao_frota_leve: string | null
}

export type FonteDoKm = 'odometro' | 'rastro'
export type FonteDoFuso = 'uf' | 'coordenada' | 'filial' | 'padrao'

export interface AnomaliaFrotaLeve {
  uuid: string
  regra: 'ligado_na_noite'
  noite: string
  tipo_frota?: TipoDeFrota
  frota: FrotaDaAnomalia | null
  /** O rastreador da sessão, para o botão Ver rastro. */
  unidade_uuid?: string | null
  /** O que o Ver rastro abre: o caminhão pela frota, a leve e a máquina pela unidade. */
  rastro?: { veiculo: string; tipo: 'caminhao' | 'unidade' } | null
  /** A sessão encostou numa carga do HUB ou num dia programado no Maquinário. */
  recortada?: boolean
  motorista_fonte?: FonteDoMotorista | null
  /** A frente da máquina na noite. */
  contrato?: { uuid: string; numero: string | null } | null
  inicio_em: string
  fim_em: string
  /** A hora local de onde o veículo estava, com o deslocamento no texto. */
  inicio_local: string
  fim_local: string
  minutos_ligado: number
  km: number | null
  km_fonte: FonteDoKm | null
  pontos: number
  motorista: string | null
  uf: string | null
  fuso: number
  fuso_rotulo: string
  fuso_fonte: FonteDoFuso | null
}

export interface PaginaDeAnomalias {
  tipo?: TipoDeFrota
  items: AnomaliaFrotaLeve[]
  total: number
  page: number
  per_page: number
  pages: number
  teto: string
  piso: string
}

export interface ItemDoRanking {
  ocorrencias: number
  minutos: number
  km: number
}

export interface IndicadoresDaFrotaLeve {
  tipo?: TipoDeFrota
  resumo: { ocorrencias: number; veiculos: number; minutos: number; km: number; sem_motorista: number; recortadas?: number }
  /** As ocorrências de cada aba no mesmo período e na mesma busca. */
  por_tipo?: Record<TipoDeFrota, number>
  por_noite: { noite: string; ocorrencias: number; minutos: number; km: number }[]
  por_hora: { hora: number; minutos: number }[]
  por_classificacao: { classificacao: string | null; ocorrencias: number }[]
  ranking_veiculos: (ItemDoRanking & { frota: FrotaDaAnomalia | null })[]
  ranking_motoristas: (ItemDoRanking & { motorista: string })[]
  filiais: string[]
  teto: string
  piso: string
  janela: string
  min_minutos: number
}
